const dateOnlyPattern = /^(\d{4})-(\d{2})-(\d{2})/;

const padDatePart = (value: number) => value.toString().padStart(2, "0");

export const toLocalDate = (
  value: Date | string | null | undefined
): Date | null => {
  if (!value) {
    return null;
  }

  if (value instanceof Date) {
    return new Date(value.getFullYear(), value.getMonth(), value.getDate());
  }

  const dateOnlyMatch = value.match(dateOnlyPattern);
  if (dateOnlyMatch) {
    const [, year, month, day] = dateOnlyMatch;
    return new Date(Number(year), Number(month) - 1, Number(day));
  }

  const parsedDate = new Date(value);
  if (Number.isNaN(parsedDate.getTime())) {
    return null;
  }

  return new Date(
    parsedDate.getFullYear(),
    parsedDate.getMonth(),
    parsedDate.getDate()
  );
};

export const toDateOnlyString = (
  value: Date | string | null | undefined
): string | null => {
  const date = toLocalDate(value);
  if (!date) {
    return null;
  }

  return `${date.getFullYear()}-${padDatePart(date.getMonth() + 1)}-${padDatePart(
    date.getDate()
  )}`;
};

export const formatDateOnlyValue = (
  value: Date | string | null | undefined,
  locale?: string
): string => {
  const date = toLocalDate(value);
  return date ? date.toLocaleDateString(locale) : "";
};
